import {Route, Routes} from "react-router-dom"
import "@fortawesome/fontawesome-free/css/all.min.css"
import "css/bulma.min.css"
import "react-sortable-tree/style.css"
import "css/style.css"
import {App} from "pages/App"
import {LoginForm} from "pages/login/LoginForm";
import {Main} from "pages/main/Main";
import {RoleListView} from "pages/role/RoleListView"
import {UpdateRoleView} from "pages/role/UpdateRoleView"
import {GroupListView} from "pages/group/GroupListView"
import {RedirectRouter} from "pages/router/RedirectRouter"
import {UserListView} from "pages/user/UserListView"
import {UpdateGroupView} from "pages/group/UpdateGroupView"
import {RegisterUser} from "pages/user/RegisterUser"
import {UpdateUserView} from "pages/user/UpdateUserView"
import {MessageRouteListView} from "pages/message-route/MessageRouteListView"
import {RegisterMessageRouteWindow} from "pages/message-route/RegisterMessageRoute"
import {UpdateMessageRouteWindow} from "pages/message-route/UpdateMessageRoute"

const MainRouter = () => {
    return (
        <Routes>
            <Route path="/" element={<App/>}>
                <Route path="" element={<Main/>}>
                    <Route path="role" element={<RedirectRouter from="/role" to="list"/>}>
                        <Route path="list" element={<RoleListView/>}/>
                        <Route path="update/:name/:view" element={<UpdateRoleView/>}/>
                    </Route>
                    <Route path="group" element={<RedirectRouter from="/group" to="list"/>}>
                        <Route path="list" element={<GroupListView/>}/>
                        <Route path="update/:id/:view" element={<UpdateGroupView/>}/>
                    </Route>
                    <Route path="user" element={<RedirectRouter from="/user" to="list"/>}>
                        <Route path="list" element={<UserListView/>}>
                            <Route path="register" element={<RegisterUser/>}/>
                        </Route>
                        <Route path="update/:id/:view" element={<UpdateUserView/>}/>
                    </Route>
                    <Route path="message-route" element={<RedirectRouter from="/message-route" to="list"/>}>
                        <Route path="list" element={<MessageRouteListView/>}>
                            <Route path="register" element={<RegisterMessageRouteWindow/>}/>
                            <Route path="update/:id" element={<UpdateMessageRouteWindow/>}/>
                        </Route>
                    </Route>
                </Route>
                <Route path="/login" element={<LoginForm/>}/>

            </Route>
        </Routes>
    )
}

export {MainRouter}